import { useMutation, useQuery } from '@tanstack/react-query';
import { Form } from 'antd';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { generalConfigApi } from '../../../../apis';
import { OvertimeRegulationSettingsValueDto } from '../../../../apis/client-axios';
import ButtonWrap from '../../../../components/ButtonWrap';
import InputWrap from '../../../../components/InputWrap';
import ToastError from '../../../../components/Toast/ToastError';
import ToastSuccess from '../../../../components/Toast/ToastSuccess';
import Widget from '../../../../components/Widget';
import { OVERTIME_API } from '../../../../constants/QueryKey';
import './style.scss';
const OverTime = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { data: overTimeData, refetch } = useQuery({
    queryKey: [OVERTIME_API],
    queryFn: () => generalConfigApi.generalConfigControllerGetOvertimeRegulationsSettings(),
  });
  useEffect(() => {
    if (overTimeData?.data.data) {
      form.setFieldsValue(overTimeData?.data.data);
    }
  }, [overTimeData?.data.data]);
  const updateOverTimeMutation = useMutation({
    mutationFn: (payload: OvertimeRegulationSettingsValueDto) =>
      generalConfigApi.generalConfigControllerUpsertOvertimeRegulationsSettings(payload),
    onSuccess: () => {
      refetch();
      ToastSuccess({
        content: intl.formatMessage({ id: 'holiday.noti.success' }),
      });
    },
    onError: () => {
      refetch();
      ToastError({
        content: intl.formatMessage({ id: 'holiday.noti.fail' }),
      });
    },
  });
  const handleUpdateOvertime = () => {
    const payload = {
      yearlyOvertimeLimit: form.getFieldValue('yearlyOvertimeLimit'),
      singleMonthLimit: form.getFieldValue('singleMonthLimit'),
      avgMonthlyOvertime: form.getFieldValue('avgMonthlyOvertime'),
      overtimeExceed: form.getFieldValue('overtimeExceed'),
    };
    updateOverTimeMutation.mutate(payload);
  };
  const validatePositiveInteger = (_, value) => {
    if (!value || !/^[1-9]\d*$/.test(value)) {
      return Promise.resolve();
    }
    return Promise.resolve();
  };
  return (
    <div className="overtime">
      <Widget
        breadcrumbs={[intl.formatMessage({ id: 'overTime.breadcums' })]}
        content={
          <Form form={form} onFinish={handleUpdateOvertime} layout="vertical">
            <div className="overtime_content">
              <h1 className="overtime_content-title">{intl.formatMessage({ id: 'overTime.content.header' })}</h1>
              <div className="overtime_content-line">
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.perYear' })}
                </span>
                <Form.Item
                  name="yearlyOvertimeLimit"
                  className="overtime_content-top-inputdate"
                  rules={[
                    {
                      validator: validatePositiveInteger,
                    },
                  ]}
                >
                  <InputWrap className="overtime_content-line-input" />
                </Form.Item>
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.withHour' })}
                </span>
              </div>
              <div className="overtime_content-line">
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.legal' })}
                </span>
                <Form.Item
                  name="avgMonthlyOvertime"
                  className="holiday_content-top-inputdate"
                  rules={[
                    {
                      validator: validatePositiveInteger,
                    },
                  ]}
                >
                  <InputWrap className="overtime_content-line-input" />
                </Form.Item>
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.withHour' })}
                </span>
              </div>
              <div className="overtime_content-line">
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.sigleMonth' })}
                </span>
                <Form.Item
                  name="singleMonthLimit"
                  className="holiday_content-top-inputdate"
                  rules={[
                    {
                      validator: validatePositiveInteger,
                    },
                  ]}
                >
                  <InputWrap className="overtime_content-line-input" />
                </Form.Item>
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.lessHour' })}
                </span>
              </div>
              <div className="overtime_content-line">
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.moon' })}
                </span>
                <Form.Item
                  name="overtimeExceed"
                  className="holiday_content-top-inputdate"
                  rules={[
                    {
                      validator: validatePositiveInteger,
                    },
                  ]}
                >
                  <InputWrap className="overtime_content-line-input" />
                </Form.Item>
                <span className="overtime_content-line-text">
                  {intl.formatMessage({ id: 'overTime.content.aYear' })}
                </span>
              </div>
              <div className="overtime_content-button">
                <ButtonWrap
                  disabled={updateOverTimeMutation.isPending}
                  htmlType="submit"
                  className="overtime_content-button-save"
                >
                  {intl.formatMessage({ id: 'overTime.button.save' })}
                </ButtonWrap>
              </div>
            </div>
          </Form>
        }
        title={intl.formatMessage({ id: 'overTime.title' })}
      />
    </div>
  );
};
export default OverTime;
